import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import {AdminAvailableModals} from '../admin-available-modals';

@Component({
    selector: 'app-confirm-reactivate-user',
    templateUrl: './confirm-reactivate-user.component.html',
    standalone: false
})
export class ConfirmReactivateUserComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('confirmReactivateUser', { static: true }) public modalView: ModalDirective;

  ngAfterViewInit() {
    this.modalId = AdminAvailableModals.CONFIRM_ENABLE_USER;
    this.modalView.show();
  }

  public returnType(obj) {
    return typeof obj;
  }
}
